module.exports = __webpack_public_path__ + "static/media/priest-logo.383a9c11.png";